import React from 'react';
import PropTypes from 'prop-types';

const PaymentType = ({ data }) => {
  let displayText = "";
  switch (data){
    case 1:
      displayText = "Dráttarvextir fyrst";
      break;
    case 2:
      displayText = "Elsti gjalddagi fyrst";
      break;
    default:
      displayText = "Ekki þekkt tegund";
      break;
  }
  return (
    <span>{displayText}</span>
  );
};

PaymentType.propTypes = {
  data: PropTypes.number,
};

export default PaymentType;



// WEBPACK FOOTER //
// ./src/pages/Calculation/Display/PaymentType.js